import Enumerable from "linq";
import { IBehaviorDocumentEditorPatientProfileConfiguration, PatientProfileUpdateKinds } from "../configuration/IConfiguration";
import { Document } from "../document";
import { IItem, instanceOfIPatientProfileInformationApplicable } from "./items";
import { PatientProfileItem, PatientProfileInformation } from "../patient";

export class PatientProfileUpdater {
  constructor(private _configuration: IBehaviorDocumentEditorPatientProfileConfiguration) {
  }
  
  public update(document: Document): void {
    if (this._configuration.updateKind === PatientProfileUpdateKinds.None) {
      // 何もしない
      return;
    }
    if (this._configuration.updateKind === PatientProfileUpdateKinds.NeedConfirm
      || this._configuration.updateKind === PatientProfileUpdateKinds.NeedConfirmIfModifiedWithBlankIgnore
      || this._configuration.updateKind === PatientProfileUpdateKinds.NeedConfirmIfModifiedWithBlankOverwrite) {
      throw new Error("患者プロフィールの確認ダイアログ表示は未実装です。");
    }
    this.overWrite(document.patientProfile, document.itemSets[0].items);
  }

  private overWrite(info: PatientProfileInformation, items: IItem[]): void {
    if (this._configuration.isEditable) {
      // 文書編集中にUIから編集可能な場合は常に更新されているとみなす（編集UIは使っていないし廃止予定だが念のため）
      info.isUpdated = true;
    }
    const keys = Enumerable.from(info.items)
      .where(i => !!i.name)
      .select(i => i.name)
      .distinct()
      .toArray();
    const newItems = this.createPatientProfileItems(keys, items);
    for (const patientProfileitem of info.items) {
      const targetItems = Enumerable.from(newItems)
        .where(i => i.name === patientProfileitem.name)
        .toArray();
      if (targetItems.length === 0) { continue; }
      
      const newValue = this.extractPatientProfileValue(targetItems);
      if (patientProfileitem.value === newValue) { continue; }

      info.isUpdated = true;
      // TODO:spliceのほうがよい？
      patientProfileitem.value = newValue;
    }
  }

  private extractPatientProfileValue(profileItems: PatientProfileItem[]): string {
    if (profileItems.length === 0) { return null; }
    // 円選択・チェックで「初期値を選択（未選択時は空）」が指定されている場合は同じnameで複数のitemが発生する
    const found = Enumerable.from(profileItems).firstOrDefault(p => !!p.value);
    return !!found
      ? found.value
      : profileItems[0].value;
  }

  private createPatientProfileItems(keys: string[], items: IItem[]): PatientProfileItem[] {
    const newProfileItems: PatientProfileItem[] = [];
    for (const key of keys) {
      for (const item of items) {
        if (!instanceOfIPatientProfileInformationApplicable(item)) { continue; }
        if (!item.isPatientProfileKeyMatched(key)) { continue; }
        const newProfileItem = item.createPatientProfileItem();
        if (newProfileItem) {
          newProfileItems.push(newProfileItem);
        }
      }
    }
    return newProfileItems;
  }
}
